import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import React from 'react';

interface CardElement extends HTMLElement {
  color?: string;
}

const OpCard = createWrapper<CardElement>('op-card');

export default OpCard;
